import { ReactNode } from "react";
import { cn } from "@tellescope/utils";

interface FileFieldItemRowProps {
  preview: ReactNode;
  title: string;
  subtitle: string;
  status?: ReactNode;
  actions?: ReactNode;
  variant?: "default" | "error" | "muted";
  className?: string;
}

export const FileFieldItemRow = ({
  preview,
  title,
  subtitle,
  status,
  actions,
  variant = "default",
  className,
}: FileFieldItemRowProps) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2 p-2 border rounded-md bg-muted/30",
        variant === "muted" && "opacity-70",
        variant === "error" && "border-red-500",
        className
      )}
    >
      {preview}
      <div className="flex-1 min-w-0">
        <p className="text-sm truncate">{title}</p>
        <p className="text-xs text-muted-foreground">{subtitle}</p>
      </div>
      {status}
      {actions}
    </div>
  );
};
